import PropTypes from 'prop-types';
import { intlShape } from '@prospectus/common/types/intlShape';
import {
  FIRST_LEVEL_RESULTS, SECOND_LEVEL_RESULTS,
} from '@utils/search';

const ProductPropTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  imageHeader: PropTypes.string.isRequired,
  imageLogo: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  label: PropTypes.string,
  marketingURL: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  additionalTrackingParams: PropTypes.shape({}),
  pageType: PropTypes.string.isRequired,
  resultsLevel: PropTypes.oneOf([FIRST_LEVEL_RESULTS, SECOND_LEVEL_RESULTS, '']),
  inProspectus: PropTypes.bool,
  organizationShortCodeOverride: PropTypes.string,
  organizationLogoOverrideUrl: PropTypes.string,
  hasDeviceParam: PropTypes.bool,
  webView: PropTypes.bool,
  inYearValue: PropTypes.shape({
    perLeadUsa: PropTypes.number,
    perLeadInternational: PropTypes.number,
    perClickUsa: PropTypes.number,
    perClickInternational: PropTypes.number,
  }),
};

const CrossProductPropTypes = {
  key: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string,
  }).isRequired,
  prospectusPath: PropTypes.string.isRequired,
  owners: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    logoImageUrl: PropTypes.string,
  })).isRequired,
  activeCourseRun: PropTypes.shape({
    key: PropTypes.string,
    marketingUrl: PropTypes.string,
  }).isRequired,
  courseType: PropTypes.string.isRequired,
};

const ProductDefaultProps = {
  label: null,
  resultsLevel: '',
  additionalTrackingParams: {},
  inProspectus: false,
  organizationShortCodeOverride: null,
  organizationLogoOverrideUrl: null,
  hasDeviceParam: false,
  webView: false,
  inYearValue: {},
};

export default ProductPropTypes;
export { ProductDefaultProps, CrossProductPropTypes };
